import { render, staticRenderFns } from "./ClientHistory.vue?vue&type=template&id=27d486a8&scoped=true"
import script from "./ClientHistory.vue?vue&type=script&lang=js"
export * from "./ClientHistory.vue?vue&type=script&lang=js"
import style0 from "./ClientHistory.vue?vue&type=style&index=0&id=27d486a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d486a8",
  null
  
)

export default component.exports